import { render, staticRenderFns } from "./CreateInventory.vue?vue&type=template&id=21dd6ccd"
import script from "./CreateInventory.vue?vue&type=script&lang=js"
export * from "./CreateInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports